<section [formGroup]="formGroup" *ngIf="options">
    <mat-slide-toggle [checked]="checked" (change)="toggle($event.checked)">{{checked ? (onValue?.label || question.label) : (offValue?.label || question.label)}}</mat-slide-toggle>

    <mat-form-field appearance="outline" class="always-hidden">
        <input type="text" matInput [formControlName]="controlName">
    </mat-form-field>

    <mat-error *ngIf="control && control.hasError('required') && control.dirty">
        <span [innerHTML]="Validation.getRequiredMessage(question)">&nbsp;</span>
    </mat-error>
</section>
